import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface ResidencyPresence { country: string; days: number; isForeign: boolean; state: 'ok' | 'approaching' | 'exceeded' }
export interface ResidencyEmployee { employeeId: string; name: string; homeCountry: string; presence: ResidencyPresence[] }
export interface ResidencyResult { threshold: number; approaching: number; windowDays: number; flagged: number; employees: ResidencyEmployee[] }

export interface AssessCitation { topic: string; country: string; summary: string; source: string; url: string | null }
export interface AssessResult {
  home: string; host: string;
  flags: { daysPresent: number; threshold: number; residencyShift: boolean; peRisk: boolean; hasContractAuthority: boolean; fixedPlace: boolean; totalizationTreaty: string | null };
  citations: AssessCitation[];
  narrative: string | null;
}

export function useResidency() {
  return useQuery({
    queryKey: ['border-buddy', 'residency'],
    queryFn: async () => (await api.get<ResidencyResult>('/api/border-buddy/residency')).data,
  });
}

export function useAssess() {
  return useMutation({
    mutationFn: async (input: { homeCountry: string; hostCountry: string; daysPresent: number; hasContractAuthority?: boolean; fixedPlace?: boolean }) =>
      (await api.post<AssessResult>('/api/border-buddy/assess', input)).data,
  });
}
